import { render, staticRenderFns } from "./SpcmAnalyticsCaseSummary.vue?vue&type=template&id=6a08697c"
import script from "./SpcmAnalyticsCaseSummary.vue?vue&type=script&lang=js"
export * from "./SpcmAnalyticsCaseSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports